import { gamePieceColors } from '../../../enums/enums'

/*export const minionPeridotAIParams =
{
    rateOfError: 4,
    superGemPriority: 0,
    specialAbilityPriority: 0,
    chainPriority: 2,
    heightAversion: 6,
    biasTowardsColor: gamePieceColors.gem1,
    aggression: 1,
/*
//version boss
export const minionPeridotAIParams =
{   
    specialAbilityPriority: 0.5,   
    dropPieceTimer: 0.6,
    reactionSpeed: 0.05,    
}
*/
//medio estable
export const minionPeridotAIParams =
{
    rateOfError: 10,
    superGemPriority: 0,
    specialAbilityPriority: 0,
    chainPriority: 2,
    heightAversion: 1,
    biasTowardsColor: gamePieceColors.gem1,
    aggression: 10,
    dropPieceTimer: 10,
    reactionSpeed: 0.05,
    specialAbilityUsageRate: 1,
    hasFutureSight: false,
}

/*
export const minionPeridotAIParams =
{
    rateOfError: 4,
    superGemPriority: 0,
    specialAbilityPriority: 0,
    chainPriority: 5,
    heightAversion: 6,
    biasTowardsColor: gamePieceColors.gem4,
    aggression: 9,
    dropPieceTimer: 0.6,
    reactionSpeed: 0.05,
    specialAbilityUsageRate: 6,
    hasFutureSight: true,
}
*/
export const stevenAIParams =
{    
    specialAbilityPriority: 0.2,   
    dropPieceTimer: 0.5,
    reactionSpeed: 0.05,
}

export const pearlAIParams =
{    
    specialAbilityPriority: 0.2,   
    dropPieceTimer: 0.5,
    reactionSpeed: 0.05,
}

export const garnetAIParams =
{    
    specialAbilityPriority: 0.2,   
    dropPieceTimer: 0.5,
    reactionSpeed: 0.05,
}

export const amethystAIParams =
{    
    specialAbilityPriority: 0.2,   
    dropPieceTimer: 0.5,
    reactionSpeed: 0.05,
}

export const minionJasperAIParams =
{   
    specialAbilityPriority: 0,   
    dropPieceTimer: 1.2,
    reactionSpeed: 0.2,    
}

export const minionYDAIParams =
{    
    specialAbilityPriority: 0,   
    dropPieceTimer: 0.8,
    reactionSpeed: 0.1, 
}

export const peridotAIParams =
{    
    specialAbilityPriority: 0.2,   
    dropPieceTimer: 1.5,
    reactionSpeed: 0.25, 
}

export const jasperAIParams =
{   
    specialAbilityPriority: 0.2,    
    dropPieceTimer: 1,
    reactionSpeed: 0.15,
}

export const yellowDiamondAIParams =
{    
    specialAbilityPriority: 0.2,   
    dropPieceTimer: 0.5,
    reactionSpeed: 0.05,
}